/**
 * Created by kachavas on 1/21/16.
 */
angular
  .module('ui-ng-popover')
  .directive('phxSmartPopover', function ($timeout, $popover, $window, $sce, popoverDataService, $interpolate) {
    'use strict';
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var startTimer,
          hideTimer,
          hideDelay = 500;
        var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;

        var popoverOptions = {
          placement: attrs.placement || 'auto',
          title: attrs.title,
          content: attrs.content,
          key: attrs.key || attrs.phxSmartPopover,
          trigger: 'manual click focus',
          html: true,
          customClass: attrs.customClass,
          delay: attrs.delay,
          container: attrs.container || 'body',
          viewport: attrs.viewport || {
            selector: 'body',
            padding: 0
          }
        };

        if (!_.isEmpty(_.trim(popoverOptions.key))) {
          popoverOptions.title = popoverDataService.getPopoverTitle(popoverOptions.key);
          popoverOptions.content = popoverDataService.getPopoverContent(popoverOptions.key);
        }
        popoverOptions.content = $sce.trustAsHtml(popoverOptions.content);
        scope.pop = $popover(element, popoverOptions);

        var adjustVerticalPosition = function adjustVerticalPosition() {
          //AUTO POSITION
          /*
           Popover has auto positioning already built in, So it handles left and right overflow.
           Below code fixes the issue with bottom positioned popover from flowing out of view.
           */
          var popover = scope.pop.$element;
          if (popover && !(scope.pop.$options.placement === 'left' || scope.pop.$options.placement === 'right')) {
            var offset = element.offset(),
              bottom_available_y = $window.pageYOffset + $window.innerHeight - offset.top,
              top_available_y = offset.top - $window.pageYOffset,
              position = bottom_available_y < top_available_y ? 'top' : 'bottom';
            // Adjust position to which ever direction has space
            scope.pop.$options.placement = position; //flip the placement direction
            popover.removeClass('top bottom ').addClass(position); //adjust class to fix the positioning of the arrow
            requestAnimationFrame(function () {
              scope.pop.$applyPlacement();
            });
          }
        };

        var isValidOffset = function (elemOffset) {
          return !_.isUndefined(elemOffset.top) && !_.isUndefined(elemOffset.left)
            ? elemOffset.top > 0 && elemOffset.left > 0
            : false;
        };

        var showPopover = function showPopover() {
          //Don't show popover when a title or content is not provided or when there is no valid offset
          var elHasValidOffset = isValidOffset(element.offset());
          if (!_.isEmpty(popoverOptions.title) && !_.isEmpty(popoverOptions.content) && elHasValidOffset) {
            var contentSource = attrs.content,
              titleSource = attrs.title;
            if (!_.isEmpty(_.trim(popoverOptions.key))) {
              contentSource = popoverDataService.getPopoverContent(popoverOptions.key);
              titleSource = popoverDataService.getPopoverTitle(popoverOptions.key);
            }
            if ($sce.trustAsHtml(contentSource) !== popoverOptions.content || titleSource !== popoverOptions.title) {
              popoverOptions.content = $sce.trustAsHtml(contentSource);
              popoverOptions.title = titleSource;
              scope.pop.destroy();
              scope.pop = $popover(element, popoverOptions);
              scope.pop.$promise.then(function () {
                scope.pop.show();
              });
            } else {
              scope.pop.show();
            }
            adjustVerticalPosition();
          }
        };

        var hidePopover = function hidePopover() {
          scope.pop.hide();
          clearTimeout(hideTimer);
        };

        var mouseEnterFunction = function mouseEnterFunction() {
          clearTimeout(hideTimer);
          startTimer = setTimeout(function () {
            showPopover();
            $('.popover')
              .on('mouseenter', function () {
                clearTimeout(hideTimer);
              })
              .on('mouseleave', function () {
                $('.popover').off('mouseenter mouseleave');
                hidePopover();
              });
          }, hideDelay);
        };

        var mouseLeaveFunction = function mouseLeaveFunction() {
          clearTimeout(startTimer); //Dont trigger
          hideTimer = setTimeout(function () {
            hidePopover();
          }, hideDelay);
        };

        element.on('mouseenter', mouseEnterFunction);
        element.on('mouseleave', mouseLeaveFunction);

        var textContent = element.text() || '';
        var iconTitle = attrs.iconTitle || '';

        textContent = $interpolate(textContent)(scope);
        var ariaLabel = !_.isEmpty(_.trim(popoverOptions.key))
          ? angular.element('<p>' + popoverOptions.title + '. ' + popoverOptions.content + '</p>').text()
          : angular.element('<p>' + attrs.title + '. ' + attrs.content + '</p>').text();

        textContent = _.isUndefined(textContent) ? '' : textContent;

        element.attr({
          //Build aria-label with title and content
          'aria-label': textContent + ' ' + iconTitle + ' ' + ariaLabel
        });

        if (!attrs.tabindex) {
          //Add tabIndex to make it accessible via keyboard
          element.attr({ tabindex: 0 });
        }

        scope.$on('$destroy', function () {
          hidePopover();
          element.off('mouseenter mouseleave');
        });
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popover/src/custom/smart_popover.js